import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./WhyChooseUsSection.css";

const whyUsData = [
  {
    icon: "fas fa-medal",
    title: "براءة اختراع خليجية",
    desc: "تخصصنا مثبت رسمياً بحصولنا على براءات اختراع تؤكد تفردنا وتضمن أعلى معايير السلامة.",
  },
  {
    icon: "fas fa-tools",
    title: "مصنّعون ومبتكرون",
    desc: "تميزنا ينبع من كوننا مصنّعين ومبتكرين أصليين لمنتجاتنا بالكامل، لا موزعين أو وكلاء.",
  },
  {
    icon: "fas fa-shield-alt",
    title: "قوة وتصميم أنيق",
    desc: "نقدم حلولاً مبتكرة تجمع بين قوة التحمل والأمان العالي والتصميم العصري الأنيق.",
  },
  {
    icon: "fas fa-globe-asia",
    title: "تغطية للمملكة والخليج",
    desc: "نلبي كافة الاحتياجات ونخدم عملاءنا في جميع مدن المملكة العربية السعودية ودول الخليج.",
  },
];

const WhyChooseUsSection = () => {
  const chooseRef = useRef(null);
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );

    if (chooseRef.current) observer.observe(chooseRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="why-us"
      className={`choose-section ${animate ? "animate" : ""}`}
      ref={chooseRef}
    >
      <Container>
        {/* الهيدر ينزل الأول */}
        <Row className="justify-content-center">
          <Col lg={8} className="text-center header-fade">
            <div className="section-header mb-5">
              <h2 className="section-title">لماذا تختارنا؟</h2>
              <div className="title-underline"></div>
            </div>
          </Col>
        </Row>
        
        {/* الكروت تظهر كارت ورا التاني بالتتابع */}
        <Row className="justify-content-center text-center">
          {whyUsData.map((item, idx) => (
            <Col 
              md={6} 
              lg={3} 
              className="mb-4 card-fade-col" 
              key={idx}
              style={{ transitionDelay: `${0.25 + idx * 0.15}s` }}
            >
              <div className="choose-card">
                <i className={`${item.icon} icon`}></i>
                <h5>{item.title}</h5>
                <p>{item.desc}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseUsSection;